import { useMemo } from 'react';

const useUrlSearchParams = (search: string) =>
  useMemo(() => new URLSearchParams(search), [search]);

export default useUrlSearchParams;
